/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CriteriaAnalyzeResponse} from '../models/CriteriaAnalyzeResponse';
import type {Error} from '../models/Error';
import type {UserUsageCriteria} from '../models/UserUsageCriteria';

export interface AnalyzeUsageCriteria$Request {
    userUsageCriteria: UserUsageCriteria;
}

export interface AnalyzeUsageCriteria$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const analyzeUsageCriteriaRequest = createAction<PayloadData<void, AnalyzeUsageCriteria$Request>>('USAGE_REPORTS_CRITERIA__ANALYZE_USAGE_CRITERIA__REQUEST');
export const analyzeUsageCriteriaSuccess = createAction<PayloadData<CriteriaAnalyzeResponse, AnalyzeUsageCriteria$Request>>('USAGE_REPORTS_CRITERIA__ANALYZE_USAGE_CRITERIA__SUCCESS');
export const analyzeUsageCriteriaFailure = createAction<PayloadData<Error, AnalyzeUsageCriteria$Request, true>>('USAGE_REPORTS_CRITERIA__ANALYZE_USAGE_CRITERIA__FAILURE');

export const analyzeUsageCriteriaActions = [
    analyzeUsageCriteriaRequest,
    analyzeUsageCriteriaSuccess,
    analyzeUsageCriteriaFailure
] as const;

/**
 * @param {UserUsageCriteria} meta.userUsageCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const analyzeUsageCriteria = (meta: AnalyzeUsageCriteria$Request, config?: AnalyzeUsageCriteria$Config) => {
    return {
        CALL_API: {
            types: analyzeUsageCriteriaActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/reports/criteria/user-usage/analysis`,
            TRANSPORT_REQUEST_BODY: meta.userUsageCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

